import type { RequiredTargetingFormType } from '@openx/types/targeting/targetingPresets.ts';
import { useMemo } from 'react';
import { useTargetingContext } from '../../../utils/context/TargetingContext.tsx';
import { RequiredTargetingSectionKeys } from '../context/types.ts';
import { useChannelInitialState } from '../hooks/initialState/useChannelInitialState.tsx';
import { useReadOnlyChannelInitialState } from '../hooks/readOnlyInitialState/useReadOnlyChannelInitialState.tsx';
import { useSyncInitialTargeting } from '../hooks/useSyncInitialTargeting.ts';
import { TargetingPresetSection } from '../TargetingPresetSection/TargetingPresetSection.tsx';

type ChannelSectionProps = {
  targetingParams?: RequiredTargetingFormType | null;
  readOnly?: boolean;
};

export const ChannelSection = ({ readOnly, targetingParams }: ChannelSectionProps) => {
  const { useDistributionChannelOptions } = useTargetingContext();
  const { isDistributionChannelLoading, distributionChannel: distributionChannelMap } = useDistributionChannelOptions();

  const readOnlyInitialState = useReadOnlyChannelInitialState(targetingParams);
  const editableInitialState = useChannelInitialState();
  const initialState = useMemo(
    () => (readOnly ? readOnlyInitialState : editableInitialState),
    [readOnly, editableInitialState, readOnlyInitialState]
  );

  useSyncInitialTargeting({
    isLoading: isDistributionChannelLoading,
    sectionKey: RequiredTargetingSectionKeys.CHANNEL,
    initialState,
    externalOptionsMap: distributionChannelMap,
  });

  return (
    <TargetingPresetSection
      name="distribution_channel"
      sectionKey={RequiredTargetingSectionKeys.CHANNEL}
      label={initialState.label}
      elements={initialState.elements}
      isLoading={isDistributionChannelLoading}
      readOnly={!!readOnly}
    />
  );
};
